import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';
import { TimeZoneOption } from '../models/time-zone-option';

export const timeZoneOptionActions = createEagerSelectActions<TimeZoneOption>('[Time Zone Options]');
